import * as RestApi from 'core/network/RestApi';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';
import { DEFAULT_DASHBOARD_ID } from '../constants';

export const useUrlGenerator = (locale: string) => {
  const { dashboardId, siteId, brandId } = useParams<{ dashboardId?: string; siteId?: string; brandId?: string }>();
  const id = dashboardId ?? DEFAULT_DASHBOARD_ID;

  let prefix = '';

  if (siteId) {
    prefix = `/sites/${siteId}`;
  }

  if (brandId) {
    prefix = `/brands/${brandId}`;
  }

  return useQuery(['looker-dahboard-url', `${locale}-${id}-${prefix}`], async () => {
    const res = await RestApi.get<{
      url: string;
    }>(`${prefix}/looker_embed_url`, {
      dashboard_id: id,
      embed_domain: window.location.origin,
      locale,
    });
    return res.data;
  });
};
